import agsEn from "./locales/en/ags.json";
import appEn from "./locales/en/app.json";
import bdEn from "./locales/en/bd.json";
import ccEn from "./locales/en/cc.json";
import commonEn from "./locales/en/common.json";
import componentsEn from "./locales/en/components.json";
import dssEn from "./locales/en/dss.json";
import erEn from "./locales/en/er.json";
import fcEn from "./locales/en/fc.json";
import lsEn from "./locales/en/ls.json";
import mmEn from "./locales/en/mm.json";
import mvEn from "./locales/en/mv.json";
import ocEn from "./locales/en/oc.json";
import pdEn from "./locales/en/pd.json";
import pfEn from "./locales/en/pf.json";
import piEn from "./locales/en/pi.json";
import ppEn from "./locales/en/pp.json";
import psdEn from "./locales/en/psd.json";
import reportsEn from "./locales/en/reports.json";
import sscEn from "./locales/en/ssc.json";
import tvEn from "./locales/en/tv.json";
import wcEn from "./locales/en/wc.json";
import agsEs from "./locales/es/ags.json";
import appEs from "./locales/es/app.json";
import bdEs from "./locales/es/bd.json";
import ccEs from "./locales/es/cc.json";
import commonEs from "./locales/es/common.json";
import componentsEs from "./locales/es/components.json";
import erEs from "./locales/es/er.json";
import fcEs from "./locales/es/fc.json";
import lsEs from "./locales/es/ls.json";
import mmEs from "./locales/es/mm.json";
import mvEs from "./locales/es/mv.json";
import ocEs from "./locales/es/oc.json";
import pdEs from "./locales/es/pd.json";
import pfEs from "./locales/es/pf.json";
import piEs from "./locales/es/pi.json";
import ppEs from "./locales/es/pp.json";
import psdEs from "./locales/es/psd.json";
import reportsEs from "./locales/es/reports.json";
import sscEs from "./locales/es/ssc.json";
import tvEs from "./locales/es/tv.json";
import wcEs from "./locales/es/wc.json";
import appNl from "./locales/nl/app.json";
import commonNl from "./locales/nl/common.json";
import componentsNl from "./locales/nl/components.json";
import dssNl from "./locales/nl/dss.json";
import wcNl from "./locales/nl/wc.json";
import agsPtBr from "./locales/pt-BR/ags.json";
import appPtBr from "./locales/pt-BR/app.json";
import bdPtBr from "./locales/pt-BR/bd.json";
import ccPtBr from "./locales/pt-BR/cc.json";
import commonPtBr from "./locales/pt-BR/common.json";
import componentsPtBr from "./locales/pt-BR/components.json";
import erPtBr from "./locales/pt-BR/er.json";
import fcPtBr from "./locales/pt-BR/fc.json";
import lsPtBr from "./locales/pt-BR/ls.json";
import mmPtBr from "./locales/pt-BR/mm.json";
import mvPtBr from "./locales/pt-BR/mv.json";
import ocPtBr from "./locales/pt-BR/oc.json";
import pdPtBr from "./locales/pt-BR/pd.json";
import pfPtBr from "./locales/pt-BR/pf.json";
import piPtBr from "./locales/pt-BR/pi.json";
import ppPtBr from "./locales/pt-BR/pp.json";
import psdPtBr from "./locales/pt-BR/psd.json";
import reportsPtBr from "./locales/pt-BR/reports.json";
import sscPtBr from "./locales/pt-BR/ssc.json";
import tvPtBr from "./locales/pt-BR/tv.json";
import wcPtBr from "./locales/pt-BR/wc.json";

export const defaultNS = "common";

export const resources = {
  en: {
    common: commonEn,
    components: componentsEn,
    app: appEn,
    ags: agsEn,
    reports: reportsEn,
    psd: psdEn,
    pi: piEn,
    pd: pdEn,
    dss: dssEn,
    fc: fcEn,
    bd: bdEn,
    wc: wcEn,
    mm: mmEn,
    pf: pfEn,
    tv: tvEn,
    pp: ppEn,
    mv: mvEn,
    cc: ccEn,
    er: erEn,
    oc: ocEn,
    ls: lsEn,
    ssc: sscEn,
  },
  "pt-BR": {
    common: commonPtBr,
    components: componentsPtBr,
    app: appPtBr,
    ags: agsPtBr,
    reports: reportsPtBr,
    psd: psdPtBr,
    pi: piPtBr,
    pd: pdPtBr,
    fc: fcPtBr,
    bd: bdPtBr,
    wc: wcPtBr,
    mm: mmPtBr,
    pf: pfPtBr,
    tv: tvPtBr,
    pp: ppPtBr,
    mv: mvPtBr,
    cc: ccPtBr,
    er: erPtBr,
    oc: ocPtBr,
    ls: lsPtBr,
    ssc: sscPtBr,
  },
  es: {
    common: commonEs,
    components: componentsEs,
    app: appEs,
    ags: agsEs,
    reports: reportsEs,
    psd: psdEs,
    pi: piEs,
    pd: pdEs,
    fc: fcEs,
    bd: bdEs,
    wc: wcEs,
    mm: mmEs,
    pf: pfEs,
    tv: tvEs,
    pp: ppEs,
    mv: mvEs,
    cc: ccEs,
    er: erEs,
    oc: ocEs,
    ls: lsEs,
    ssc: sscEs,
  },
  nl: {
    app: appNl,
    common: commonNl,
    components: componentsNl,
    dss: dssNl,
    wc: wcNl,
  },
} as const;
